var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPigUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF96A0"
    },
    d: "M512,11.24c0,0-8.25,143.994-107.348,168.768l-74.324-82.582C355.103,64.394,425.496-0.082,512,11.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M404.652,180.009l-39.494-43.882c14.719-46.958,80.785-113.024,145.413-111.335 C505.676,61.223,485.1,159.897,404.652,180.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF96A0"
    },
    d: "M0,11.24c0,0,8.25,143.994,107.348,168.768l74.324-82.582C156.897,64.394,86.504-0.082,0,11.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M107.348,180.009l39.494-43.882C132.123,89.169,66.057,23.103,1.428,24.792 C6.324,61.223,26.9,159.897,107.348,180.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAAB4"
    },
    d: "M462.451,320.398c0,100.339-92.433,181.68-206.455,181.68s-206.455-81.34-206.455-181.68 c0-115.615,92.433-247.746,206.455-247.746S462.451,204.783,462.451,320.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC4655"
    },
    d: "M185.253,403.893c8.888,28.305,33.329,48.636,62.089,48.636h17.308 c29.068,0,53.725-20.769,62.369-49.549L185.253,403.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M348.818,372.484c0,52.988-64.93,36.235-92.749,36.235c-27.239,0-92.71,16.753-92.71-36.235 c0-54.119,41.463-92.106,92.676-92.106S348.818,318.365,348.818,372.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF96A0"
    },
    d: "M121.112,323.363c0-98.217,56.178-207.355,134.961-250.707c-0.026,0-0.051-0.003-0.077-0.003 c-114.022,0-206.455,132.131-206.455,247.746c0,94.685,82.321,172.416,187.409,180.881 C168.36,469.09,121.112,401.527,121.112,323.363z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4744 -0.8803 0.8803 0.4744 -197.3232 382.7459)",
    style: {
      fill: "#A5465A"
    },
    cx: 221.864,
    cy: 356.619,
    rx: 20.495,
    ry: 16.703
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4744 0.8803 -0.8803 0.4744 466.4368 -67.9822)",
    style: {
      fill: "#A5465A"
    },
    cx: 290.149,
    cy: 356.62,
    rx: 20.495,
    ry: 16.703
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M165.156,270.849L165.156,270.849c-13.683,0-24.775-11.092-24.775-24.775v-8.258 c0-13.683,11.092-24.775,24.775-24.775l0,0c13.683,0,24.775,11.092,24.775,24.775v8.258 C189.93,259.757,178.838,270.849,165.156,270.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M165.155,213.042v28.904c0,6.841,5.546,12.387,12.387,12.387c6.841,0,12.387-5.546,12.387-12.387 v-4.129C189.93,224.134,178.838,213.042,165.155,213.042z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 165.16,
    cy: 229.561,
    r: 8.258
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M346.836,270.849L346.836,270.849c-13.683,0-24.775-11.092-24.775-24.775v-8.258 c0-13.683,11.092-24.775,24.775-24.775l0,0c13.683,0,24.775,11.092,24.775,24.775v8.258 C371.611,259.757,360.519,270.849,346.836,270.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M346.836,213.042v28.904c0,6.841,5.546,12.387,12.387,12.387s12.387-5.546,12.387-12.387v-4.129 C371.611,224.134,360.519,213.042,346.836,213.042z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 346.84,
    cy: 229.561,
    r: 8.258
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigUserIcon);
export default __webpack_public_path__ + "static/media/pig-user-icon.aa09c98cb2a1d90e734897a74a84e372.svg";
export { ForwardRef as ReactComponent };